import onboardingMessages from '@/messages/onboarding';
import UserPasswordPage from '@/modules/user/UserPasswordPage';
import { setInitialUserPassword, verifyAuthToken } from '@/services/api/requests/user';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from '@/context/auth/deriveAuth';

// /password-setup/owpjjUs8b0YaG62cMIVPAmScJnlKyKUz?email=filipsavic1995@yahoo.com&roles=membercare
const PasswordSetup = () => {
  const { authToken } = Route.useParams();
  const { email, roles, isValidLink } = Route.useSearch();

  return (
    <UserPasswordPage
      pageTitle={onboardingMessages.emailSuccessfullyVerified}
      pageDescription={onboardingMessages.createYourPassword}
      email={email}
      authToken={authToken}
      isValidLink={isValidLink}
      userRoles={roles ? roles.split(',') : []}
      verifyTokenCallback={() => verifyAuthToken({ token: authToken, email })}
      setPasswordCallback={(password: string) =>
        setInitialUserPassword({
          email,
          newPassword: password,
          token: authToken,
        })
      }
    />
  );
};

export const Route = createFileRoute('/password-setup/$authToken')({
  component: PasswordSetup,
  validateSearch: (search: Record<string, unknown>) => {
    const email = typeof search.email === 'string' ? search.email : '';
    const roles = typeof search.roles === 'string' ? search.roles : '';

    return {
      email,
      roles,
      isValidLink: email.trim().length > 0,
    };
  },
  beforeLoad: async () => {
    const { isAuthenticated } = getAuthSnapshot();
    if (isAuthenticated) {
      throw redirect({
        to: '/',
      });
    }
  },
});
